// The visible singular name of each resource, as the whole admin writes it.
const NOUNS: Record<string, string> = {
  cryptoOrders: "transaction",
  cryptoConversions: "conversion",
  paymentLinks: "payment link",
  projects: "entity",
  accounts: "account",
  users: "user",
  gasStationTransfers: "gas station transfer",
  gasStationStatements: "gas station statement",
};

export const resourceNoun = (resource: string) => NOUNS[resource] || "item";
